import { Card, Space, Drawer, Affix, Badge, Form, Tag, Tooltip } from "antd";
import React, { useState } from "react";
import "./index.css";
import {
  Button,
  Text,
  Title,
} from "Components/CommonComponents/GeneralComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  storeSelectedTag,
  storeQuestionFilter,
  StoreSubtypeEnabledInFilter,
} from "redux/action/questionAction";
import LeftArrow from "Assets/Icons/LeftArrow";
import QuestionFilterAntd from "Pages/Questions/QuestionsHomeScreen/QustionFilterAntd";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const QuestionsHeader = (props) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    totalQuestionCount,
    setRefresh,
    fetchQuestion,
    filterValues,
    setfilterValues,
    userVerifiedCount,
    sortBy,
    sortDir,
    limit,
  } = props;
  const [open, setOpen] = useState(false);
  const [bucketArr, setBucketArr] = useState([]);
  const [usersListArr, setUsersListAr] = useState([]);
  const [inputTextLanguage, setInputTextLangauge] = useState(null);
  const [subSubEnabled, setSubSubEnabled] = useState(false);
  const [tags, settags] = useState([
    { newcourse: { courseName: "" }, newnode: [] },
  ]);
  const { selectedNode } = useSelector((state) => state.questionReducer);
  const [state, setState] = useState(
    selectedNode
      ? selectedNode
      : {
          checkbutton: false,
          isPaneOpen: false,
          isPaneOpenLeft: false,
          selectedTag: {
            node: "",
            course: "",
            newcourse: "",
            newnode: "",
            fkCourse: null,
            fkNode: "",
          },
          inputTag: null,
          nodeIndex: null,
          index: null,
          questionisPaneOpen: false,
        }
  );

  const showFilterDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const ClearAllFilter = () => {
    form.resetFields();
    settags([{ newcourse: { courseName: "" }, newnode: [] }]);
    setState({
      ...state,
      inputTag: null,
      selectedTag: {
        ...state.selectedTag,
        node: "",
        course: "",
        newcourse: "",
        newnode: "",
        fkCourse: null,
        fkNode: "",
      },
    });
    setSubSubEnabled(false);
    dispatch(storeSelectedTag({}));
    dispatch(StoreSubtypeEnabledInFilter(true));
    setfilterValues({ hintStatus: "HU" });
    dispatch(storeQuestionFilter({}));
    setInputTextLangauge(null);
    setRefresh(new Date().getMilliseconds());
  };
  const filterLength = Object.values(filterValues).filter(
    (item) => item != undefined && item != "" && item != null
  ).length;
  const backHandler = () => {
    navigate(-1);
  };
  return (
    <>
      <Affix offsetTop={0}>
        <Card className="mb-1">
          <div className="questionHeader">
            <div className="questionTitleGroup">
              <div>
                <LeftArrow onClick={() => backHandler()} />
              </div>
              <Title level={4}>{" Hints and Solution Verification"}</Title>
              <Tooltip title={"Total questions"}>
                <Text
                  type="secondary"
                  className="totalCountinHeaderStyle"
                  level={4}
                >
                  &nbsp;|&nbsp;{totalQuestionCount}&nbsp;
                </Text>
              </Tooltip>
              {userVerifiedCount && userVerifiedCount != "" ? (
                <Space>
                  <Tooltip title={"Questions verified by you"}>
                    <Tag>Verified Questions:&nbsp;{userVerifiedCount}</Tag>
                  </Tooltip>
                </Space>
              ) : null}
            </div>
            <div className="questionHeaderButtonGroup">
              <Space size={"small"}>
                {filterLength > 0 ? (
                  <Button
                    type="text"
                    danger
                    ghost
                    onClick={() => ClearAllFilter()}
                  >
                    Clear All
                  </Button>
                ) : null}
                <Badge count={filterLength}>
                  <Button onClick={() => showFilterDrawer()}>Filter</Button>
                </Badge>
              </Space>
            </div>
          </div>
        </Card>
      </Affix>
      <Drawer
        title={"Filter"}
        placement="right"
        size={"large"}
        onClose={onClose}
        open={open}
      >
        <QuestionFilterAntd
          form={form}
          setRefresh={setRefresh}
          tags={tags}
          settags={settags}
          state={state}
          setState={setState}
          setfilterValues={setfilterValues}
          filterValues={filterValues}
          fetchQuestion={fetchQuestion}
          usersListArr={usersListArr}
          setUsersListAr={setUsersListAr}
          bucketArr={bucketArr}
          setBucketArr={setBucketArr}
          sortBy={sortBy}
          sortDir={sortDir}
          limit={limit}
          onCloseDrawer={onClose}
          subSubEnabled={subSubEnabled}
          setSubSubEnabled={setSubSubEnabled}
          inputTextLanguage={inputTextLanguage}
          setInputTextLangauge={setInputTextLangauge}
        />
      </Drawer>
    </>
  );
};

QuestionsHeader.propTypes = {
  totalQuestionCount: PropTypes.object,
  filterValues: PropTypes.any,
  setRefresh: PropTypes.func,
  fetchQuestion: PropTypes.func,
  setfilterValues: PropTypes.func,
  userVerifiedCount: PropTypes.number,
  sortBy: PropTypes.string,
  sortDir: PropTypes.string,
  limit: PropTypes.number,
};
export default QuestionsHeader;
